/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface IUserManagementClientV1 {

    /**
     * Determine whether service is alive
     * @return Service is alive
     */
    ping(): Promise<void>;

    /**
     * Get the public IP address of the requestor
     * @return Returns public Ip address
     */
    getIpAddress(): Promise<string>;

    /**
     * Takes login credentials. A user could signin with the UserName with the E-mail address or the phone number. Password must be provided.
     * @return Success
     */
    login(body: Login): Promise<LoginResult>;

    /**
     * Takes an existing valid token and exchanges it with a new one creating a new device session in the progress.
     * @return Success
     */
    exchangeToken(body: ExchangeToken): Promise<LoginResult>;

    /**
     * @return Success
     */
    loginValidate(): Promise<void>;

    /**
     * Provides a new refresh and access token for old values.
     * @param x_token Access Token
     * @param x_refresh_token Refresh token
     * @param clientId optional client Id
     * @return Refresh token
     */
    refreshToken(x_token: string, x_refresh_token: string, clientId: string): Promise<LoginResult>;

    /**
     * Search users.
     * @param search (optional) 
     * @param excludeContactList (optional) 
     * @return List of users can be found in the body of the response.
     */
    searchUsers(pageNumber: number, pageSize: number, search: string | undefined, excludeContactList: boolean | undefined): Promise<UserWithCompanyName[]>;

    /**
     * Create a user - Administrator only.
     * @return User Created
     */
    createUser(body: FullUserForCreate): Promise<void>;

    /**
     * Create a user using an invitation token
     * @return User Created
     */
    createUserFromToken(body: CreateUserRequest): Promise<void>;

    /**
     * Create multiple users - Requires Administrator.
     * @return Users Created
     */
    createBatchUsers(body: CreateBatchUserRequest): Promise<void>;

    /**
     * @return Password is reset.
     */
    changePassword(body: ChangePasswordRequest): Promise<void>;

    /**
     * @return Password token is valid.
     */
    validatePasswordResetToken(passwordResetToken: string): Promise<void>;

    /**
     * @return Password is reset.
     */
    resetPasswordWithToken(passwordResetToken: string, body: string): Promise<void>;

    /**
     * @return An email has been sent to introduce how to reset the password if the user exists.
     */
    requestPasswordReset(body: ResetPasswordRequest): Promise<void>;

    /**
     * Get settings for current user
     * @return User settings can be found in the body of the response.
     */
    getCurrentUserSettings(pageNumber: number, pageSize: number): Promise<UserSetting[]>;

    /**
     * Update settings for current user
     * @param body an array of settings to update.
     * @return User successfully updated.
     */
    updateCurrentUserSettings(body: UserSetting[]): Promise<void>;

    /**
     * Get current user setting by key
     * @param settingKey Key of Setting to retrieve
     * @return Setting can be found in the body of the response.
     */
    getCurrentUserSettingByKey(settingKey: string): Promise<UserSetting>;

    /**
     * Update current user setting by key
     * @param settingKey Key of Setting to retrieve
     * @param body Value to set.
     * @return Setting successfully updated.
     */
    updateCurrentUserSettingByKey(settingKey: string, body: string): Promise<void>;

    /**
     * Delete current user setting by key
     * @param settingKey Key of Setting to delete
     * @return Setting successfully deleted.
     */
    deleteCurrentUserSettingByKey(settingKey: string): Promise<void>;

    /**
     * Get Release Channels for given user
     * @param userId Id of User to retrieve
     * @return Release Channels can be found in the body of the response.
     */
    getReleaseChannelsForUser(userId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]>;

    /**
     * Add ReleaseChannel to User
     * @param userId Id of User to add release channel to
     * @return Release Channel added to User
     */
    addReleaseChannelToUser(userId: string, body: ReleaseChannel): Promise<void>;

    /**
     * Get Release Channel by id for given user
     * @param userId Id of User to retrieve
     * @param releaseChannelId Id of ReleaseChannel to retrieve
     * @return Release Channel can be found in the body of the response.
     */
    getReleaseChannelByIdForUser(userId: string, releaseChannelId: string): Promise<ReleaseChannel>;

    /**
     * Remove ReleaseChannel from User
     * @param userId Id of User to update
     * @param releaseChannelId Id of ReleaseChannel to remove
     * @return ReleaseChannel removed from user
     */
    removeReleaseChannelFromUser(userId: string, releaseChannelId: string): Promise<void>;

    /**
     * Get settings for given user
     * @param userId Id of user to retrieve settings for
     * @return User settings can be found in the body of the response.
     */
    getUserSettings(userId: string, pageNumber: number, pageSize: number): Promise<UserSetting[]>;

    /**
     * Update settings for current user
     * @param userId Id of user to update settings for.
     * @param body an array of settings to update.
     * @return User successfully updated.
     */
    updateUserSettings(userId: string, body: UserSetting[]): Promise<void>;

    /**
     * Get setting by key for given user
     * @param userId Id of User to retrieve setting for
     * @param settingKey Key of Setting to retrieve
     * @return Setting can be found in the body of the response.
     */
    getUserSettingByKey(userId: string, settingKey: string): Promise<UserSetting>;

    /**
     * Update setting by key for given user
     * @param userId Id of User to update setting for
     * @param settingKey Key of Setting to update
     * @param body value to set.
     * @return Setting successfully updated.
     */
    updateUserSettingByKey(userId: string, settingKey: string, body: string): Promise<void>;

    /**
     * Delete setting by key for given user
     * @param userId Id of User to delete setting for
     * @param settingKey Key of Setting to delete
     * @return Setting successfully deleted.
     */
    deleteUserSettingByKey(userId: string, settingKey: string): Promise<void>;

    /**
     * Get permissions for current user
     * @return User permissions can be found in the body of the response.
     */
    getCurrentUserPermissions(): Promise<Permission>;

    /**
     * Get permissions for user
     * @param userId Id of User to delete
     * @return User permissions can be found in the body of the response.
     */
    getUserPermissions(userId: string): Promise<Permission>;

    /**
     * Delete User.
     * @param userId Id of User to delete
     * @return User deleted.
     */
    deleteUser(userId: string): Promise<void>;

    /**
     * Get user by id.
     * @param userId Id of User to retrieve
     * @param includeAvatar (optional) If avatar image URL should be included
     * @return User data can be found in the body of the response.
     */
    getUserById(userId: string, includeAvatar: boolean | undefined): Promise<UserWithCompanyName>;

    /**
     * Update given user.
     * @param userId Id of User to update
     * @param body a User object containing updated values.
     * @return User successfully updated.
     */
    updateUserById(userId: string, body: FullUserForUpdate): Promise<void>;

    /**
     * Retrieve avatar configuration for user
     * @return success
     */
    getUserAvatarConfiguration(userId: string): Promise<UserAvatarConfiguration>;

    /**
     * Delete avatar configuration for user - Administrator only
     * @return success
     */
    deleteUserAvatarConfiguration(userId: string): Promise<void>;

    /**
     * Set avatar configuration for user
     * @return success
     */
    setUserAvatarConfiguration(userId: string, body: UserAvatarConfigurationWithoutId): Promise<void>;

    /**
     * Retrieve default avatar configuration
     * @return success
     */
    getDefaultAvatarConfiguration(): Promise<UserAvatarConfigurationWithoutId>;

    /**
     * Retrieve avatar permissions for a given user. Requires Administrator access.
     * @param userId Id of User to retrieve avatar permissions for
     * @return success
     */
    getUserAvatarPermissions(userId: string, pageNumber: number, pageSize: number): Promise<string[]>;

    /**
     * Add an avatar permission to a given user. Requires Administrator access.
     * @param userId Id of User to set avatar permissions for.
     * @return success
     */
    addUserAvatarPermission(userId: string, body: string): Promise<void>;

    /**
     * Remove an avatar permission for a given user. Requires Administrator access.
     * @param userId Id of User to remove permissions for
     * @param avatarId Id of Avatar to remove.
     * @return success
     */
    deleteUserAvatarPermission(userId: string, avatarId: string): Promise<void>;

    /**
     * Get group memberships for user.  Requires Administrator access.
     * @param userId Id of User to retrieve groups for
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getUserGroupsOfSpecificUser(userId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]>;

    /**
     * Get all user groups. Requires Administrator access.
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getAllUserGroups(pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]>;

    /**
     * Create a UserGroup. Requires Administrator access.
     * @return UserGroup information can be found in the body of the response.
     */
    createUserGroup(body: UserGroupWithoutId): Promise<UserGroup>;

    /**
     * Get Release Channels for User Group
     * @param userGroupId Id of UserGroup to retrieve
     * @return Release Channels can be found in the body of the response.
     */
    getReleaseChannelsForUserGroup(userGroupId: string): Promise<ReleaseChannel[]>;

    /**
     * Add ReleaseChannel to User Group
     * @param userGroupId Id of UserGroup to add release channel to
     * @return Release Channel added to UserGroup
     */
    addReleaseChannelToUserGroup(userGroupId: string, body: ReleaseChannel): Promise<void>;

    /**
     * Remove ReleaseChannel from User Group
     * @param userGroupId Id of UserGroup to update
     * @param releaseChannelId Id of ReleaseChannel to remove
     * @return ReleaseChannel removed from group
     */
    removeReleaseChannelFromUserGroup(userGroupId: string, releaseChannelId: string): Promise<void>;

    /**
     * Get UserGroup by id.
     * @param userGroupId Id of UserGroup to retrieve
     * @return UserGroup data can be found in the body of the response.
     */
    getUserGroupById(userGroupId: string): Promise<UserGroup>;

    /**
     * Delete UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to remove user from
     * @return UserGroup Deleted.
     */
    deleteUserGroup(userGroupId: string): Promise<void>;

    /**
     * Update a UserGroup. Requires Administrator access.
     * @param userGroupId Id of UserGroup to update
     * @return UserGroup updated.
     */
    updateUserGroup(userGroupId: string, body: UserGroupWithoutId): Promise<void>;

    /**
     * Get permissions for UserGroup by id.
     * @param userGroupId Id of UserGroup to retrieve permissions for
     * @return Permission data can be found in the body of the response.
     */
    getPermissionsForUserGroupById(userGroupId: string): Promise<Permission>;

    /**
     * Update permissions for UserGroup by id.
     * @param userGroupId Id of UserGroup to update permissions for
     * @return Permission data updated.
     */
    updatePermissionsForUserGroupById(userGroupId: string, body: Permission): Promise<void>;

    /**
     * Get Users for UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to retrieve users for
     * @param search (optional) 
     * @return User information can be found in the body of the response.
     */
    getUsersForUserGroup(userGroupId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserWithCompanyName[]>;

    /**
     * Add User to UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to add users to
     * @return User added to group
     */
    addUserToUserGroup(userGroupId: string, body: string): Promise<void>;

    /**
     * Add many users to UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to add users to
     * @return Partial Success. User Ids that could not be found are in the body of the response.
     */
    addManyUsersToUserGroup(userGroupId: string, body: string[]): Promise<string[]>;

    /**
     * Remove user from usergroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to remove user from
     * @param userId Id of user to remove from group
     * @return User removed from group.
     */
    removeUserFromUserGroup(userGroupId: string, userId: string): Promise<void>;

    /**
     * Get contacts for user. Requires Administrator access.
     * @param userId Id of User to retrieve contacts for
     * @return Contact information can be found in the body of the response.
     */
    getUserContacts(userId: string, pageNumber: number, pageSize: number): Promise<User[]>;

    /**
     * Create Contact. Requires Administrator access.
     * @param userId Id of User to create Contact for
     * @return Contact created.
     */
    createUserContact(userId: string, body: string): Promise<void>;

    /**
     * Remove contact from user
     * @param userId Id of User to remove Contact for
     * @param contactUserId Id of Contact to remove
     * @return Contact removed.
     */
    removeUserContact(userId: string, contactUserId: string): Promise<void>;

    /**
     * Get my legacy user id.
     * @return User can be found in the body of the response.
     */
    getCurrentUserLegacyId(): Promise<number>;

    /**
     * Get my user data.
     * @return User can be found in the body of the response.
     */
    getCurrentUser(): Promise<UserWithCompanyName>;

    /**
     * Update my user information.
     * @param body a User object containing updated values.
     * @return User information successfully updated.
     */
    updateCurrentUser(body: User): Promise<void>;

    /**
     * @return Locale can be found in the body of the response.
     */
    getCurrentUserLocale(): Promise<string>;

    /**
     * @return Permissions can be found in the body of the response.
     */
    getCurrentUserAvatarPermissions(pageNumber: number, pageSize: number): Promise<string[]>;

    /**
     * Retrieve avatar configuration for current user
     * @return Configuration can be found in the body of the response.
     */
    getCurrentUserAvatarConfiguration(): Promise<UserAvatarConfiguration>;

    /**
     * Set avatar configuration for current user
     * @return success
     */
    setCurrentUserAvatarConfiguration(body: UserAvatarConfigurationWithoutId): Promise<void>;

    /**
     * Create a contact request.
     * @param userId user to request as contact.
     * @return Contact request created.
     */
    createContactRequest(userId: string): Promise<void>;

    /**
     * Get my contact requests.
     * @return Contact requestor information can be found in the body of the response.
     */
    getCurrentUserContactRequests(pageNumber: number, pageSize: number): Promise<ContactRequest[]>;

    /**
     * Get sent contact requests for current user
     * @return Contact requestor information can be found in the body of the response.
     */
    getSentContactRequests(pageNumber: number, pageSize: number): Promise<ContactRequest[]>;

    /**
     * Cancel sent contact requests for current user
     * @return Contact Request canceled
     */
    cancelSentContactRequest(userId: string): Promise<void>;

    /**
     * Get contact request by id.
     * @param userId Request to retrieve.
     * @return Contact requestor information can be found in the body of the response.
     */
    getContactRequest(userId: string): Promise<ContactRequest>;

    /**
     * Accept or reject contact request.
     * @param userId Request to accept.
     * @return Contact Request accepted or rejected.
     */
    acceptOrRejectContactRequest(userId: string, body: boolean): Promise<void>;

    /**
     * Get my contacts.
     * @param roomId (optional) 
     * @param includeStatus (optional) 
     * @param onlineOnly (optional) 
     * @param search (optional) 
     * @return Contact information can be found in the body of the response.
     */
    getCurrentUserContacts(pageNumber: number, pageSize: number, roomId: string | undefined, includeStatus: boolean | undefined, onlineOnly: boolean | undefined, search: string | undefined): Promise<UserWithStatus[]>;

    /**
     * Create Contact
     * @return Contact created.
     */
    createCurrentUserContact(body: string): Promise<void>;

    /**
     * Get contact.
     * @param userId Id of contact to retrieve
     * @param includeStatus (optional) 
     * @return Contact information can be found in the body of the response.
     */
    getCurrentUserContactById(userId: string, includeStatus: boolean | undefined): Promise<UserWithStatus>;

    /**
     * Remove Contact
     * @param userId Id of contact to remove
     * @return Contact deleted.
     */
    removeCurrentUserContact(userId: string): Promise<void>;

    /**
     * Download profile picture for user
     * @param userId Id of User to retrieve profile picture for
     * @param accessToken Access token to authorize download
     * @param last_updated (optional) used for DesktopApp tracking
     * @return The profile picture
     */
    getUserProfilePicture(userId: string, accessToken: string, last_updated: string | undefined): Promise<FileResponse>;

    /**
     * Upload a profile picture for current user
     * @param file (optional) 
     * @return Upload successful.
     */
    uploadProfilePicture(file: FileParameter | undefined): Promise<void>;

    /**
     * Get recent rooms for current user
     * @return Sorted list of recent room metadata IDs (most recent room is first)
     */
    getRecentRoomsOfCurrentUser(): Promise<string[]>;

    /**
     * Add recent rooms for current user, potentially removing an old one or pushing existing one to the front
     * @return Rooms added to recent rooms list successfully
     */
    addRecentRoomsOfCurrentUser(body: string[]): Promise<void>;

    /**
     * Get groups for current user
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getUserGroupsOfCurrentUser(pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]>;

    /**
     * Get all user groups for a given company
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getAllUserGroupsForCompany(companyId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]>;

    /**
     * Get replay approvers for company
     * @return List of replay approvers can be found in the body of the response.
     */
    getReplayApproversByCompany(companyId: string, pageNumber: number, pageSize: number): Promise<UserWithCompanyName[]>;

    /**
     * Get Users for company
     * @param search (optional) 
     * @param licenseId (optional) License ID to filter users by its whitelist
     * @return List of users can be found in the body of the response.
     */
    getUsersByCompany(companyId: string, pageNumber: number, pageSize: number, search: string | undefined, licenseId: string | undefined): Promise<UserWithCompanyName[]>;

    /**
     * Get list of pending invitations for given company - requires CompanyAdministrator or higher
     * @return List of pending invitations can be found in the body of the response.
     */
    getPendingInvitationsForCompany(companyId: string, pageNumber: number, pageSize: number): Promise<InvitationSummary[]>;

    /**
     * Invite user - Requires CompanyAdministrator or higher
     * @return Invitation Created
     */
    inviteUser(companyId: string, body: InvitationWithoutId): Promise<void>;

    /**
     * Delete invitation for given email - requires CompanyAdministrator or higher
     * @return Invitation deleted.
     */
    deleteInvitationByEmail(inviteeEmail: string): Promise<void>;

    /**
     * Resend invitation email with new token.
     * @return Invitation resent.
     */
    resendInvitation(inviteeEmail: string): Promise<void>;

    /**
     * Validate invitation token
     * @return Token is valid
     */
    validateInvitationToken(invitationToken: string): Promise<string>;

    /**
     * Invite administrator - Requires Administrator
     * @return Invitation Created
     */
    inviteAdmin(body: InvitationWithoutId): Promise<void>;

    /**
     * Get all user groups that provide access to a room
     * @param search (optional) 
     * @return List of current user groups that give access to the room and match the criteria
     */
    getUserGroupsForRoom(roomId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]>;

    /**
     * Validate new password criteria against user info.
     * @return Password validation result in detail
     */
    validateNewPasswordWithToken(passwordResetToken: string, body: string): Promise<PasswordValidationResult>;

    /**
     * Get Users for given Release Channel
     * @param releaseChannelId Id of Release Channel to retrieve
     * @return Users can be found in the body of the response. UserGroupId is empty if release channel is assigned directly.
     */
    getUsersForReleaseChannel(releaseChannelId: string, pageNumber: number, pageSize: number): Promise<UserAccessData[]>;

    /**
     * Get User Groups for given Release Channel
     * @param releaseChannelId Id of Release Channel to retrieve
     * @return User Groups can be found in the body of the response.
     */
    getUserGroupsForReleaseChannel(releaseChannelId: string, pageNumber: number, pageSize: number): Promise<UserGroupAccessData[]>;
}

export class UserManagementClientV1 extends JwtApiBase implements IUserManagementClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Determine whether service is alive
     * @return Service is alive
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get the public IP address of the requestor
     * @return Returns public Ip address
     */
    getIpAddress(): Promise<string> {
        let url_ = this.baseUrl + "/ip-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIpAddress(_response);
        });
    }

    protected processGetIpAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Takes login credentials. A user could signin with the UserName with the E-mail address or the phone number. Password must be provided.
     * @return Success
     */
    login(body: Login): Promise<LoginResult> {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Credentials are invalid", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User with specified credentials not found", status, _responseText, _headers);
            });
        } else if (status === 405) {
            return response.text().then((_responseText) => {
            return throwException("User must change password before they can log in", status, _responseText, _headers);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            return throwException("User has been removed", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * Takes an existing valid token and exchanges it with a new one creating a new device session in the progress.
     * @return Success
     */
    exchangeToken(body: ExchangeToken): Promise<LoginResult> {
        let url_ = this.baseUrl + "/login/exchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExchangeToken(_response);
        });
    }

    protected processExchangeToken(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Existing token is invalid", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User with specified credentials not found", status, _responseText, _headers);
            });
        } else if (status === 405) {
            return response.text().then((_responseText) => {
            return throwException("User must change password before they can log in", status, _responseText, _headers);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            return throwException("User has been removed", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * @return Success
     */
    loginValidate(): Promise<void> {
        let url_ = this.baseUrl + "/login/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLoginValidate(_response);
        });
    }

    protected processLoginValidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Provides a new refresh and access token for old values.
     * @param x_token Access Token
     * @param x_refresh_token Refresh token
     * @param clientId optional client Id
     * @return Refresh token
     */
    refreshToken(x_token: string, x_refresh_token: string, clientId: string): Promise<LoginResult> {
        let url_ = this.baseUrl + "/login/refresh?";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "x-token": x_token !== undefined && x_token !== null ? "" + x_token : "",
                "x-refresh-token": x_refresh_token !== undefined && x_refresh_token !== null ? "" + x_refresh_token : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Tokens could not be validated/parsed", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(<any>null);
    }

    /**
     * Search users.
     * @param search (optional) 
     * @param excludeContactList (optional) 
     * @return List of users can be found in the body of the response.
     */
    searchUsers(pageNumber: number, pageSize: number, search: string | undefined, excludeContactList: boolean | undefined): Promise<UserWithCompanyName[]> {
        let url_ = this.baseUrl + "/users?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (excludeContactList === null)
            throw new Error("The parameter 'excludeContactList' cannot be null.");
        else if (excludeContactList !== undefined)
            url_ += "excludeContactList=" + encodeURIComponent("" + excludeContactList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: Response): Promise<UserWithCompanyName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithCompanyName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName[]>(<any>null);
    }

    /**
     * Create a user - Administrator only.
     * @return User Created
     */
    createUser(body: FullUserForCreate): Promise<void> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("User already exists", status, _responseText, _headers);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Auth0 rate limit exceeded", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Create a user using an invitation token
     * @return User Created
     */
    createUserFromToken(body: CreateUserRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/create-from-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserFromToken(_response);
        });
    }

    protected processCreateUserFromToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Token not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("User already exists", status, _responseText, _headers);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Auth0 rate limit exceeded", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Create multiple users - Requires Administrator.
     * @return Users Created
     */
    createBatchUsers(body: CreateBatchUserRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBatchUsers(_response);
        });
    }

    protected processCreateBatchUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Token not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("User already exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Password is reset.
     */
    changePassword(body: ChangePasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("New password is invalid.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Old password is incorrect", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Password token is valid.
     */
    validatePasswordResetToken(passwordResetToken: string): Promise<void> {
        let url_ = this.baseUrl + "/users/reset-password/{passwordResetToken}";
        if (passwordResetToken === undefined || passwordResetToken === null)
            throw new Error("The parameter 'passwordResetToken' must be defined.");
        url_ = url_.replace("{passwordResetToken}", encodeURIComponent("" + passwordResetToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidatePasswordResetToken(_response);
        });
    }

    protected processValidatePasswordResetToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Password reset token not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Password is reset.
     */
    resetPasswordWithToken(passwordResetToken: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/reset-password/{passwordResetToken}";
        if (passwordResetToken === undefined || passwordResetToken === null)
            throw new Error("The parameter 'passwordResetToken' must be defined.");
        url_ = url_.replace("{passwordResetToken}", encodeURIComponent("" + passwordResetToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPasswordWithToken(_response);
        });
    }

    protected processResetPasswordWithToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Password reset token not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return An email has been sent to introduce how to reset the password if the user exists.
     */
    requestPasswordReset(body: ResetPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/users/request-password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get settings for current user
     * @return User settings can be found in the body of the response.
     */
    getCurrentUserSettings(pageNumber: number, pageSize: number): Promise<UserSetting[]> {
        let url_ = this.baseUrl + "/users/me/settings?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserSettings(_response);
        });
    }

    protected processGetCurrentUserSettings(response: Response): Promise<UserSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSetting[]>(<any>null);
    }

    /**
     * Update settings for current user
     * @param body an array of settings to update.
     * @return User successfully updated.
     */
    updateCurrentUserSettings(body: UserSetting[]): Promise<void> {
        let url_ = this.baseUrl + "/users/me/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrentUserSettings(_response);
        });
    }

    protected processUpdateCurrentUserSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to update this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get current user setting by key
     * @param settingKey Key of Setting to retrieve
     * @return Setting can be found in the body of the response.
     */
    getCurrentUserSettingByKey(settingKey: string): Promise<UserSetting> {
        let url_ = this.baseUrl + "/users/me/settings/{settingKey}";
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserSettingByKey(_response);
        });
    }

    protected processGetCurrentUserSettingByKey(response: Response): Promise<UserSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSetting>(<any>null);
    }

    /**
     * Update current user setting by key
     * @param settingKey Key of Setting to retrieve
     * @param body Value to set.
     * @return Setting successfully updated.
     */
    updateCurrentUserSettingByKey(settingKey: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/settings/{settingKey}";
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrentUserSettingByKey(_response);
        });
    }

    protected processUpdateCurrentUserSettingByKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Delete current user setting by key
     * @param settingKey Key of Setting to delete
     * @return Setting successfully deleted.
     */
    deleteCurrentUserSettingByKey(settingKey: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/settings/{settingKey}";
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCurrentUserSettingByKey(_response);
        });
    }

    protected processDeleteCurrentUserSettingByKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get Release Channels for given user
     * @param userId Id of User to retrieve
     * @return Release Channels can be found in the body of the response.
     */
    getReleaseChannelsForUser(userId: string, pageNumber: number, pageSize: number): Promise<ReleaseChannel[]> {
        let url_ = this.baseUrl + "/users/{userId}/release-channels?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseChannelsForUser(_response);
        });
    }

    protected processGetReleaseChannelsForUser(response: Response): Promise<ReleaseChannel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseChannel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannel[]>(<any>null);
    }

    /**
     * Add ReleaseChannel to User
     * @param userId Id of User to add release channel to
     * @return Release Channel added to User
     */
    addReleaseChannelToUser(userId: string, body: ReleaseChannel): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/release-channels";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddReleaseChannelToUser(_response);
        });
    }

    protected processAddReleaseChannelToUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to add content for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or ReleaseChannel not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("ReleaseChannel already exists for user", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get Release Channel by id for given user
     * @param userId Id of User to retrieve
     * @param releaseChannelId Id of ReleaseChannel to retrieve
     * @return Release Channel can be found in the body of the response.
     */
    getReleaseChannelByIdForUser(userId: string, releaseChannelId: string): Promise<ReleaseChannel> {
        let url_ = this.baseUrl + "/users/{userId}/release-channels/{releaseChannelId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseChannelByIdForUser(_response);
        });
    }

    protected processGetReleaseChannelByIdForUser(response: Response): Promise<ReleaseChannel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseChannel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or ReleaseChannel not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannel>(<any>null);
    }

    /**
     * Remove ReleaseChannel from User
     * @param userId Id of User to update
     * @param releaseChannelId Id of ReleaseChannel to remove
     * @return ReleaseChannel removed from user
     */
    removeReleaseChannelFromUser(userId: string, releaseChannelId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/release-channels/{releaseChannelId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveReleaseChannelFromUser(_response);
        });
    }

    protected processRemoveReleaseChannelFromUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to remove ReleaseChannel from this user.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get settings for given user
     * @param userId Id of user to retrieve settings for
     * @return User settings can be found in the body of the response.
     */
    getUserSettings(userId: string, pageNumber: number, pageSize: number): Promise<UserSetting[]> {
        let url_ = this.baseUrl + "/users/{userId}/settings?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSettings(_response);
        });
    }

    protected processGetUserSettings(response: Response): Promise<UserSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSetting[]>(<any>null);
    }

    /**
     * Update settings for current user
     * @param userId Id of user to update settings for.
     * @param body an array of settings to update.
     * @return User successfully updated.
     */
    updateUserSettings(userId: string, body: UserSetting[]): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/settings";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSettings(_response);
        });
    }

    protected processUpdateUserSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to update this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get setting by key for given user
     * @param userId Id of User to retrieve setting for
     * @param settingKey Key of Setting to retrieve
     * @return Setting can be found in the body of the response.
     */
    getUserSettingByKey(userId: string, settingKey: string): Promise<UserSetting> {
        let url_ = this.baseUrl + "/users/{userId}/settings/{settingKey}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSettingByKey(_response);
        });
    }

    protected processGetUserSettingByKey(response: Response): Promise<UserSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSetting>(<any>null);
    }

    /**
     * Update setting by key for given user
     * @param userId Id of User to update setting for
     * @param settingKey Key of Setting to update
     * @param body value to set.
     * @return Setting successfully updated.
     */
    updateUserSettingByKey(userId: string, settingKey: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/settings/{settingKey}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSettingByKey(_response);
        });
    }

    protected processUpdateUserSettingByKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Delete setting by key for given user
     * @param userId Id of User to delete setting for
     * @param settingKey Key of Setting to delete
     * @return Setting successfully deleted.
     */
    deleteUserSettingByKey(userId: string, settingKey: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/settings/{settingKey}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (settingKey === undefined || settingKey === null)
            throw new Error("The parameter 'settingKey' must be defined.");
        url_ = url_.replace("{settingKey}", encodeURIComponent("" + settingKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserSettingByKey(_response);
        });
    }

    protected processDeleteUserSettingByKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to delete this setting.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or Setting not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get permissions for current user
     * @return User permissions can be found in the body of the response.
     */
    getCurrentUserPermissions(): Promise<Permission> {
        let url_ = this.baseUrl + "/users/me/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserPermissions(_response);
        });
    }

    protected processGetCurrentUserPermissions(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(<any>null);
    }

    /**
     * Get permissions for user
     * @param userId Id of User to delete
     * @return User permissions can be found in the body of the response.
     */
    getUserPermissions(userId: string): Promise<Permission> {
        let url_ = this.baseUrl + "/users/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user\'s permissions.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(<any>null);
    }

    /**
     * Delete User.
     * @param userId Id of User to delete
     * @return User deleted.
     */
    deleteUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get user by id.
     * @param userId Id of User to retrieve
     * @param includeAvatar (optional) If avatar image URL should be included
     * @return User data can be found in the body of the response.
     */
    getUserById(userId: string, includeAvatar: boolean | undefined): Promise<UserWithCompanyName> {
        let url_ = this.baseUrl + "/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (includeAvatar === null)
            throw new Error("The parameter 'includeAvatar' cannot be null.");
        else if (includeAvatar !== undefined)
            url_ += "includeAvatar=" + encodeURIComponent("" + includeAvatar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: Response): Promise<UserWithCompanyName> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithCompanyName.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName>(<any>null);
    }

    /**
     * Update given user.
     * @param userId Id of User to update
     * @param body a User object containing updated values.
     * @return User successfully updated.
     */
    updateUserById(userId: string, body: FullUserForUpdate): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserById(_response);
        });
    }

    protected processUpdateUserById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to update this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve avatar configuration for user
     * @return success
     */
    getUserAvatarConfiguration(userId: string): Promise<UserAvatarConfiguration> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-configuration";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAvatarConfiguration(_response);
        });
    }

    protected processGetUserAvatarConfiguration(response: Response): Promise<UserAvatarConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatarConfiguration.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve configuration for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatarConfiguration>(<any>null);
    }

    /**
     * Delete avatar configuration for user - Administrator only
     * @return success
     */
    deleteUserAvatarConfiguration(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-configuration";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserAvatarConfiguration(_response);
        });
    }

    protected processDeleteUserAvatarConfiguration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to delete configuration for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Set avatar configuration for user
     * @return success
     */
    setUserAvatarConfiguration(userId: string, body: UserAvatarConfigurationWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-configuration";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserAvatarConfiguration(_response);
        });
    }

    protected processSetUserAvatarConfiguration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to set configuration for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve default avatar configuration
     * @return success
     */
    getDefaultAvatarConfiguration(): Promise<UserAvatarConfigurationWithoutId> {
        let url_ = this.baseUrl + "/avatar-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultAvatarConfiguration(_response);
        });
    }

    protected processGetDefaultAvatarConfiguration(response: Response): Promise<UserAvatarConfigurationWithoutId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatarConfigurationWithoutId.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatarConfigurationWithoutId>(<any>null);
    }

    /**
     * Retrieve avatar permissions for a given user. Requires Administrator access.
     * @param userId Id of User to retrieve avatar permissions for
     * @return success
     */
    getUserAvatarPermissions(userId: string, pageNumber: number, pageSize: number): Promise<string[]> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-permissions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAvatarPermissions(_response);
        });
    }

    protected processGetUserAvatarPermissions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to retrieve avatar permissions for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Add an avatar permission to a given user. Requires Administrator access.
     * @param userId Id of User to set avatar permissions for.
     * @return success
     */
    addUserAvatarPermission(userId: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-permissions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserAvatarPermission(_response);
        });
    }

    protected processAddUserAvatarPermission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to add avatar permissions for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or avatar not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Remove an avatar permission for a given user. Requires Administrator access.
     * @param userId Id of User to remove permissions for
     * @param avatarId Id of Avatar to remove.
     * @return success
     */
    deleteUserAvatarPermission(userId: string, avatarId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/avatar-permissions/{avatarId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (avatarId === undefined || avatarId === null)
            throw new Error("The parameter 'avatarId' must be defined.");
        url_ = url_.replace("{avatarId}", encodeURIComponent("" + avatarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserAvatarPermission(_response);
        });
    }

    protected processDeleteUserAvatarPermission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to remove avatar permissions for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get group memberships for user.  Requires Administrator access.
     * @param userId Id of User to retrieve groups for
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getUserGroupsOfSpecificUser(userId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/users/{userId}/user-groups?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupsOfSpecificUser(_response);
        });
    }

    protected processGetUserGroupsOfSpecificUser(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve groups for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(<any>null);
    }

    /**
     * Get all user groups. Requires Administrator access.
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getAllUserGroups(pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/user-groups?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllUserGroups(_response);
        });
    }

    protected processGetAllUserGroups(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve groups for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(<any>null);
    }

    /**
     * Create a UserGroup. Requires Administrator access.
     * @return UserGroup information can be found in the body of the response.
     */
    createUserGroup(body: UserGroupWithoutId): Promise<UserGroup> {
        let url_ = this.baseUrl + "/user-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserGroup(_response);
        });
    }

    protected processCreateUserGroup(response: Response): Promise<UserGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserGroup.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("CompanyId doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to create this UserGroup", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup>(<any>null);
    }

    /**
     * Get Release Channels for User Group
     * @param userGroupId Id of UserGroup to retrieve
     * @return Release Channels can be found in the body of the response.
     */
    getReleaseChannelsForUserGroup(userGroupId: string): Promise<ReleaseChannel[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/release-channels";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseChannelsForUserGroup(_response);
        });
    }

    protected processGetReleaseChannelsForUserGroup(response: Response): Promise<ReleaseChannel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReleaseChannel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this UserGroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReleaseChannel[]>(<any>null);
    }

    /**
     * Add ReleaseChannel to User Group
     * @param userGroupId Id of UserGroup to add release channel to
     * @return Release Channel added to UserGroup
     */
    addReleaseChannelToUserGroup(userGroupId: string, body: ReleaseChannel): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/release-channels";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddReleaseChannelToUserGroup(_response);
        });
    }

    protected processAddReleaseChannelToUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this UserGroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup or ReleaseChannel not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("ReleaseChannel already exists in group", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Remove ReleaseChannel from User Group
     * @param userGroupId Id of UserGroup to update
     * @param releaseChannelId Id of ReleaseChannel to remove
     * @return ReleaseChannel removed from group
     */
    removeReleaseChannelFromUserGroup(userGroupId: string, releaseChannelId: string): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/release-channels/{releaseChannelId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveReleaseChannelFromUserGroup(_response);
        });
    }

    protected processRemoveReleaseChannelFromUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to remove ReleaseChannel from this UserGroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get UserGroup by id.
     * @param userGroupId Id of UserGroup to retrieve
     * @return UserGroup data can be found in the body of the response.
     */
    getUserGroupById(userGroupId: string): Promise<UserGroup> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupById(_response);
        });
    }

    protected processGetUserGroupById(response: Response): Promise<UserGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroup.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this UserGroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup>(<any>null);
    }

    /**
     * Delete UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to remove user from
     * @return UserGroup Deleted.
     */
    deleteUserGroup(userGroupId: string): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserGroup(_response);
        });
    }

    protected processDeleteUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve users for this group.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a UserGroup. Requires Administrator access.
     * @param userGroupId Id of UserGroup to update
     * @return UserGroup updated.
     */
    updateUserGroup(userGroupId: string, body: UserGroupWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserGroup(_response);
        });
    }

    protected processUpdateUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("CompanyId doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to update this UserGroup", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("UserGroup already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get permissions for UserGroup by id.
     * @param userGroupId Id of UserGroup to retrieve permissions for
     * @return Permission data can be found in the body of the response.
     */
    getPermissionsForUserGroupById(userGroupId: string): Promise<Permission> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/permissions";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissionsForUserGroupById(_response);
        });
    }

    protected processGetPermissionsForUserGroupById(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Permission.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve permissions for this usergroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Usergroup not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(<any>null);
    }

    /**
     * Update permissions for UserGroup by id.
     * @param userGroupId Id of UserGroup to update permissions for
     * @return Permission data updated.
     */
    updatePermissionsForUserGroupById(userGroupId: string, body: Permission): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/permissions";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePermissionsForUserGroupById(_response);
        });
    }

    protected processUpdatePermissionsForUserGroupById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to update permissions for this usergroup.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Usergroup not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get Users for UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to retrieve users for
     * @param search (optional) 
     * @return User information can be found in the body of the response.
     */
    getUsersForUserGroup(userGroupId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserWithCompanyName[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersForUserGroup(_response);
        });
    }

    protected processGetUsersForUserGroup(response: Response): Promise<UserWithCompanyName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithCompanyName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve users for this group.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName[]>(<any>null);
    }

    /**
     * Add User to UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to add users to
     * @return User added to group
     */
    addUserToUserGroup(userGroupId: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserToUserGroup(_response);
        });
    }

    protected processAddUserToUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to add users to this group.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User or Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Add many users to UserGroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to add users to
     * @return Partial Success. User Ids that could not be found are in the body of the response.
     */
    addManyUsersToUserGroup(userGroupId: string, body: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users/add-many";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddManyUsersToUserGroup(_response);
        });
    }

    protected processAddManyUsersToUserGroup(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Users added to group", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to add users to this group.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Remove user from usergroup. Requires CompanyAdministrator access.
     * @param userGroupId Id of group to remove user from
     * @param userId Id of user to remove from group
     * @return User removed from group.
     */
    removeUserFromUserGroup(userGroupId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users/{userId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUserFromUserGroup(_response);
        });
    }

    protected processRemoveUserFromUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve users for this group.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get contacts for user. Requires Administrator access.
     * @param userId Id of User to retrieve contacts for
     * @return Contact information can be found in the body of the response.
     */
    getUserContacts(userId: string, pageNumber: number, pageSize: number): Promise<User[]> {
        let url_ = this.baseUrl + "/users/{userId}/contacts?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserContacts(_response);
        });
    }

    protected processGetUserContacts(response: Response): Promise<User[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(User.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve contacts for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User[]>(<any>null);
    }

    /**
     * Create Contact. Requires Administrator access.
     * @param userId Id of User to create Contact for
     * @return Contact created.
     */
    createUserContact(userId: string, body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/contacts";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserContact(_response);
        });
    }

    protected processCreateUserContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to create a Contact for this user.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Contact already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Remove contact from user
     * @param userId Id of User to remove Contact for
     * @param contactUserId Id of Contact to remove
     * @return Contact removed.
     */
    removeUserContact(userId: string, contactUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/contacts/{contactUserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (contactUserId === undefined || contactUserId === null)
            throw new Error("The parameter 'contactUserId' must be defined.");
        url_ = url_.replace("{contactUserId}", encodeURIComponent("" + contactUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUserContact(_response);
        });
    }

    protected processRemoveUserContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to remove a contact from this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User does not exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get my legacy user id.
     * @return User can be found in the body of the response.
     */
    getCurrentUserLegacyId(): Promise<number> {
        let url_ = this.baseUrl + "/users/me/legacy-id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserLegacyId(_response);
        });
    }

    protected processGetCurrentUserLegacyId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * Get my user data.
     * @return User can be found in the body of the response.
     */
    getCurrentUser(): Promise<UserWithCompanyName> {
        let url_ = this.baseUrl + "/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserWithCompanyName> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithCompanyName.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName>(<any>null);
    }

    /**
     * Update my user information.
     * @param body a User object containing updated values.
     * @return User information successfully updated.
     */
    updateCurrentUser(body: User): Promise<void> {
        let url_ = this.baseUrl + "/users/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrentUser(_response);
        });
    }

    protected processUpdateCurrentUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Locale can be found in the body of the response.
     */
    getCurrentUserLocale(): Promise<string> {
        let url_ = this.baseUrl + "/users/me/locale";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserLocale(_response);
        });
    }

    protected processGetCurrentUserLocale(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Permissions can be found in the body of the response.
     */
    getCurrentUserAvatarPermissions(pageNumber: number, pageSize: number): Promise<string[]> {
        let url_ = this.baseUrl + "/users/me/avatar-permissions?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserAvatarPermissions(_response);
        });
    }

    protected processGetCurrentUserAvatarPermissions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Retrieve avatar configuration for current user
     * @return Configuration can be found in the body of the response.
     */
    getCurrentUserAvatarConfiguration(): Promise<UserAvatarConfiguration> {
        let url_ = this.baseUrl + "/users/me/avatar-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserAvatarConfiguration(_response);
        });
    }

    protected processGetCurrentUserAvatarConfiguration(response: Response): Promise<UserAvatarConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatarConfiguration.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatarConfiguration>(<any>null);
    }

    /**
     * Set avatar configuration for current user
     * @return success
     */
    setCurrentUserAvatarConfiguration(body: UserAvatarConfigurationWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/users/me/avatar-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCurrentUserAvatarConfiguration(_response);
        });
    }

    protected processSetCurrentUserAvatarConfiguration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Create a contact request.
     * @param userId user to request as contact.
     * @return Contact request created.
     */
    createContactRequest(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/{userId}/contact-requests";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateContactRequest(_response);
        });
    }

    protected processCreateContactRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Contact request already exists.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("User is already a contact.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get my contact requests.
     * @return Contact requestor information can be found in the body of the response.
     */
    getCurrentUserContactRequests(pageNumber: number, pageSize: number): Promise<ContactRequest[]> {
        let url_ = this.baseUrl + "/users/me/contact-requests?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserContactRequests(_response);
        });
    }

    protected processGetCurrentUserContactRequests(response: Response): Promise<ContactRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactRequest[]>(<any>null);
    }

    /**
     * Get sent contact requests for current user
     * @return Contact requestor information can be found in the body of the response.
     */
    getSentContactRequests(pageNumber: number, pageSize: number): Promise<ContactRequest[]> {
        let url_ = this.baseUrl + "/users/me/contact-requests/sent?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSentContactRequests(_response);
        });
    }

    protected processGetSentContactRequests(response: Response): Promise<ContactRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactRequest.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactRequest[]>(<any>null);
    }

    /**
     * Cancel sent contact requests for current user
     * @return Contact Request canceled
     */
    cancelSentContactRequest(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/contact-requests/sent/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelSentContactRequest(_response);
        });
    }

    protected processCancelSentContactRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get contact request by id.
     * @param userId Request to retrieve.
     * @return Contact requestor information can be found in the body of the response.
     */
    getContactRequest(userId: string): Promise<ContactRequest> {
        let url_ = this.baseUrl + "/users/me/contact-requests/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContactRequest(_response);
        });
    }

    protected processGetContactRequest(response: Response): Promise<ContactRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactRequest.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Contact Request not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactRequest>(<any>null);
    }

    /**
     * Accept or reject contact request.
     * @param userId Request to accept.
     * @return Contact Request accepted or rejected.
     */
    acceptOrRejectContactRequest(userId: string, body: boolean): Promise<void> {
        let url_ = this.baseUrl + "/users/me/contact-requests/{userId}/accept-or-reject";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptOrRejectContactRequest(_response);
        });
    }

    protected processAcceptOrRejectContactRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Contact Request not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get my contacts.
     * @param roomId (optional) 
     * @param includeStatus (optional) 
     * @param onlineOnly (optional) 
     * @param search (optional) 
     * @return Contact information can be found in the body of the response.
     */
    getCurrentUserContacts(pageNumber: number, pageSize: number, roomId: string | undefined, includeStatus: boolean | undefined, onlineOnly: boolean | undefined, search: string | undefined): Promise<UserWithStatus[]> {
        let url_ = this.baseUrl + "/users/me/contacts?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (roomId === null)
            throw new Error("The parameter 'roomId' cannot be null.");
        else if (roomId !== undefined)
            url_ += "roomId=" + encodeURIComponent("" + roomId) + "&";
        if (includeStatus === null)
            throw new Error("The parameter 'includeStatus' cannot be null.");
        else if (includeStatus !== undefined)
            url_ += "includeStatus=" + encodeURIComponent("" + includeStatus) + "&";
        if (onlineOnly === null)
            throw new Error("The parameter 'onlineOnly' cannot be null.");
        else if (onlineOnly !== undefined)
            url_ += "onlineOnly=" + encodeURIComponent("" + onlineOnly) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserContacts(_response);
        });
    }

    protected processGetCurrentUserContacts(response: Response): Promise<UserWithStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithStatus[]>(<any>null);
    }

    /**
     * Create Contact
     * @return Contact created.
     */
    createCurrentUserContact(body: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCurrentUserContact(_response);
        });
    }

    protected processCreateCurrentUserContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Contact already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get contact.
     * @param userId Id of contact to retrieve
     * @param includeStatus (optional) 
     * @return Contact information can be found in the body of the response.
     */
    getCurrentUserContactById(userId: string, includeStatus: boolean | undefined): Promise<UserWithStatus> {
        let url_ = this.baseUrl + "/users/me/contacts/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (includeStatus === null)
            throw new Error("The parameter 'includeStatus' cannot be null.");
        else if (includeStatus !== undefined)
            url_ += "includeStatus=" + encodeURIComponent("" + includeStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserContactById(_response);
        });
    }

    protected processGetCurrentUserContactById(response: Response): Promise<UserWithStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWithStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("User not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithStatus>(<any>null);
    }

    /**
     * Remove Contact
     * @param userId Id of contact to remove
     * @return Contact deleted.
     */
    removeCurrentUserContact(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/contacts/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveCurrentUserContact(_response);
        });
    }

    protected processRemoveCurrentUserContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Download profile picture for user
     * @param userId Id of User to retrieve profile picture for
     * @param accessToken Access token to authorize download
     * @param last_updated (optional) used for DesktopApp tracking
     * @return The profile picture
     */
    getUserProfilePicture(userId: string, accessToken: string, last_updated: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined and cannot be null.");
        else
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (last_updated === null)
            throw new Error("The parameter 'last_updated' cannot be null.");
        else if (last_updated !== undefined)
            url_ += "last_updated=" + encodeURIComponent("" + last_updated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserProfilePicture(_response);
        });
    }

    protected processGetUserProfilePicture(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve the profile picture for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The user or file was not found", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            return throwException("Error when accessing blob storage", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Upload a profile picture for current user
     * @param file (optional) 
     * @return Upload successful.
     */
    uploadProfilePicture(file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/me/profile-picture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad request. File is not a .PNG, too large, or empty.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get recent rooms for current user
     * @return Sorted list of recent room metadata IDs (most recent room is first)
     */
    getRecentRoomsOfCurrentUser(): Promise<string[]> {
        let url_ = this.baseUrl + "/users/me/rooms/recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecentRoomsOfCurrentUser(_response);
        });
    }

    protected processGetRecentRoomsOfCurrentUser(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Add recent rooms for current user, potentially removing an old one or pushing existing one to the front
     * @return Rooms added to recent rooms list successfully
     */
    addRecentRoomsOfCurrentUser(body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/users/me/rooms/recent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddRecentRoomsOfCurrentUser(_response);
        });
    }

    protected processAddRecentRoomsOfCurrentUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Rooms were not found or not available to the user", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get groups for current user
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getUserGroupsOfCurrentUser(pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/users/me/user-groups?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupsOfCurrentUser(_response);
        });
    }

    protected processGetUserGroupsOfCurrentUser(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve groups for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(<any>null);
    }

    /**
     * Get all user groups for a given company
     * @param search (optional) 
     * @return Group information can be found in the body of the response.
     */
    getAllUserGroupsForCompany(companyId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/user-groups?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllUserGroupsForCompany(_response);
        });
    }

    protected processGetAllUserGroupsForCompany(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve groups for this user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Group not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(<any>null);
    }

    /**
     * Get replay approvers for company
     * @return List of replay approvers can be found in the body of the response.
     */
    getReplayApproversByCompany(companyId: string, pageNumber: number, pageSize: number): Promise<UserWithCompanyName[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/replay-approvers?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReplayApproversByCompany(_response);
        });
    }

    protected processGetReplayApproversByCompany(response: Response): Promise<UserWithCompanyName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithCompanyName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to retrieve replay approvers for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName[]>(<any>null);
    }

    /**
     * Get Users for company
     * @param search (optional) 
     * @param licenseId (optional) License ID to filter users by its whitelist
     * @return List of users can be found in the body of the response.
     */
    getUsersByCompany(companyId: string, pageNumber: number, pageSize: number, search: string | undefined, licenseId: string | undefined): Promise<UserWithCompanyName[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/users?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByCompany(_response);
        });
    }

    protected processGetUsersByCompany(response: Response): Promise<UserWithCompanyName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserWithCompanyName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permissions to retrieve users for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserWithCompanyName[]>(<any>null);
    }

    /**
     * Get list of pending invitations for given company - requires CompanyAdministrator or higher
     * @return List of pending invitations can be found in the body of the response.
     */
    getPendingInvitationsForCompany(companyId: string, pageNumber: number, pageSize: number): Promise<InvitationSummary[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/invitations?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPendingInvitationsForCompany(_response);
        });
    }

    protected processGetPendingInvitationsForCompany(response: Response): Promise<InvitationSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvitationSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationSummary[]>(<any>null);
    }

    /**
     * Invite user - Requires CompanyAdministrator or higher
     * @return Invitation Created
     */
    inviteUser(companyId: string, body: InvitationWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/companies/{companyId}/invitations";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to invite a user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Inviter cannot be found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("User already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Delete invitation for given email - requires CompanyAdministrator or higher
     * @return Invitation deleted.
     */
    deleteInvitationByEmail(inviteeEmail: string): Promise<void> {
        let url_ = this.baseUrl + "/invitations/{inviteeEmail}";
        if (inviteeEmail === undefined || inviteeEmail === null)
            throw new Error("The parameter 'inviteeEmail' must be defined.");
        url_ = url_.replace("{inviteeEmail}", encodeURIComponent("" + inviteeEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInvitationByEmail(_response);
        });
    }

    protected processDeleteInvitationByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to delete this Invitation.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Resend invitation email with new token.
     * @return Invitation resent.
     */
    resendInvitation(inviteeEmail: string): Promise<void> {
        let url_ = this.baseUrl + "/invitations/{inviteeEmail}/resend";
        if (inviteeEmail === undefined || inviteeEmail === null)
            throw new Error("The parameter 'inviteeEmail' must be defined.");
        url_ = url_.replace("{inviteeEmail}", encodeURIComponent("" + inviteeEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendInvitation(_response);
        });
    }

    protected processResendInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to resend this Invitation.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No valid invitation found for this email address.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Validate invitation token
     * @return Token is valid
     */
    validateInvitationToken(invitationToken: string): Promise<string> {
        let url_ = this.baseUrl + "/invitations?";
        if (invitationToken === undefined || invitationToken === null)
            throw new Error("The parameter 'invitationToken' must be defined and cannot be null.");
        else
            url_ += "invitationToken=" + encodeURIComponent("" + invitationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateInvitationToken(_response);
        });
    }

    protected processValidateInvitationToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Token is not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Invite administrator - Requires Administrator
     * @return Invitation Created
     */
    inviteAdmin(body: InvitationWithoutId): Promise<void> {
        let url_ = this.baseUrl + "/invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviteAdmin(_response);
        });
    }

    protected processInviteAdmin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to invite a user.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Inviter cannot be found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("User already exists.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get all user groups that provide access to a room
     * @param search (optional) 
     * @return List of current user groups that give access to the room and match the criteria
     */
    getUserGroupsForRoom(roomId: string, pageNumber: number, pageSize: number, search: string | undefined): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/rooms/{roomId}/user-groups?";
        if (roomId === undefined || roomId === null)
            throw new Error("The parameter 'roomId' must be defined.");
        url_ = url_.replace("{roomId}", encodeURIComponent("" + roomId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupsForRoom(_response);
        });
    }

    protected processGetUserGroupsForRoom(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid pageSize or pageNumber parameters", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Room was not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(<any>null);
    }

    /**
     * Validate new password criteria against user info.
     * @return Password validation result in detail
     */
    validateNewPasswordWithToken(passwordResetToken: string, body: string): Promise<PasswordValidationResult> {
        let url_ = this.baseUrl + "/users/reset-password/{passwordResetToken}/validate";
        if (passwordResetToken === undefined || passwordResetToken === null)
            throw new Error("The parameter 'passwordResetToken' must be defined.");
        url_ = url_.replace("{passwordResetToken}", encodeURIComponent("" + passwordResetToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateNewPasswordWithToken(_response);
        });
    }

    protected processValidateNewPasswordWithToken(response: Response): Promise<PasswordValidationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordValidationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Password token was not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasswordValidationResult>(<any>null);
    }

    /**
     * Get Users for given Release Channel
     * @param releaseChannelId Id of Release Channel to retrieve
     * @return Users can be found in the body of the response. UserGroupId is empty if release channel is assigned directly.
     */
    getUsersForReleaseChannel(releaseChannelId: string, pageNumber: number, pageSize: number): Promise<UserAccessData[]> {
        let url_ = this.baseUrl + "/release-channels/{releaseChannelId}/users?";
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersForReleaseChannel(_response);
        });
    }

    protected processGetUsersForReleaseChannel(response: Response): Promise<UserAccessData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccessData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid pageSize or pageNumber parameters", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this Release Channel.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccessData[]>(<any>null);
    }

    /**
     * Get User Groups for given Release Channel
     * @param releaseChannelId Id of Release Channel to retrieve
     * @return User Groups can be found in the body of the response.
     */
    getUserGroupsForReleaseChannel(releaseChannelId: string, pageNumber: number, pageSize: number): Promise<UserGroupAccessData[]> {
        let url_ = this.baseUrl + "/release-channels/{releaseChannelId}/user-groups?";
        if (releaseChannelId === undefined || releaseChannelId === null)
            throw new Error("The parameter 'releaseChannelId' must be defined.");
        url_ = url_.replace("{releaseChannelId}", encodeURIComponent("" + releaseChannelId));
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupsForReleaseChannel(_response);
        });
    }

    protected processGetUserGroupsForReleaseChannel(response: Response): Promise<UserGroupAccessData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupAccessData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid pageSize or pageNumber parameters", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve content for this Release Channel.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupAccessData[]>(<any>null);
    }
}

export class UserAvatarConfigurationWithoutId implements IUserAvatarConfigurationWithoutId {
    avatarType!: AvatarType;
    headMeshIndex?: number;
    hairMeshIndex?: number;
    facialHairMeshIndex?: number;
    eyeWearMeshIndex?: number;
    clothingMeshIndex?: number;
    faceColorIndex?: number;
    hairColorIndex?: number;
    eyeColorIndex?: number;
    lipColorIndex?: number;
    facialHairColorIndex?: number;
    eyeWearColorIndex?: number;
    clothingColorIndex?: number;
    eyeLashColorIndex?: number;
    eyeBrowColorIndex?: number;

    constructor(data?: IUserAvatarConfigurationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatarType = _data["AvatarType"];
            this.headMeshIndex = _data["HeadMeshIndex"];
            this.hairMeshIndex = _data["HairMeshIndex"];
            this.facialHairMeshIndex = _data["FacialHairMeshIndex"];
            this.eyeWearMeshIndex = _data["EyeWearMeshIndex"];
            this.clothingMeshIndex = _data["ClothingMeshIndex"];
            this.faceColorIndex = _data["FaceColorIndex"];
            this.hairColorIndex = _data["HairColorIndex"];
            this.eyeColorIndex = _data["EyeColorIndex"];
            this.lipColorIndex = _data["LipColorIndex"];
            this.facialHairColorIndex = _data["FacialHairColorIndex"];
            this.eyeWearColorIndex = _data["EyeWearColorIndex"];
            this.clothingColorIndex = _data["ClothingColorIndex"];
            this.eyeLashColorIndex = _data["EyeLashColorIndex"];
            this.eyeBrowColorIndex = _data["EyeBrowColorIndex"];
        }
    }

    static fromJS(data: any): UserAvatarConfigurationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatarConfigurationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AvatarType"] = this.avatarType;
        data["HeadMeshIndex"] = this.headMeshIndex;
        data["HairMeshIndex"] = this.hairMeshIndex;
        data["FacialHairMeshIndex"] = this.facialHairMeshIndex;
        data["EyeWearMeshIndex"] = this.eyeWearMeshIndex;
        data["ClothingMeshIndex"] = this.clothingMeshIndex;
        data["FaceColorIndex"] = this.faceColorIndex;
        data["HairColorIndex"] = this.hairColorIndex;
        data["EyeColorIndex"] = this.eyeColorIndex;
        data["LipColorIndex"] = this.lipColorIndex;
        data["FacialHairColorIndex"] = this.facialHairColorIndex;
        data["EyeWearColorIndex"] = this.eyeWearColorIndex;
        data["ClothingColorIndex"] = this.clothingColorIndex;
        data["EyeLashColorIndex"] = this.eyeLashColorIndex;
        data["EyeBrowColorIndex"] = this.eyeBrowColorIndex;
        return data;
    }
}

export interface IUserAvatarConfigurationWithoutId {
    avatarType: AvatarType;
    headMeshIndex?: number;
    hairMeshIndex?: number;
    facialHairMeshIndex?: number;
    eyeWearMeshIndex?: number;
    clothingMeshIndex?: number;
    faceColorIndex?: number;
    hairColorIndex?: number;
    eyeColorIndex?: number;
    lipColorIndex?: number;
    facialHairColorIndex?: number;
    eyeWearColorIndex?: number;
    clothingColorIndex?: number;
    eyeLashColorIndex?: number;
    eyeBrowColorIndex?: number;
}

export class UserAvatarConfiguration extends UserAvatarConfigurationWithoutId implements IUserAvatarConfiguration {
    userAvatarConfigurationId!: string;
    userId!: string;

    constructor(data?: IUserAvatarConfiguration) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userAvatarConfigurationId = _data["UserAvatarConfigurationId"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): UserAvatarConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatarConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserAvatarConfigurationId"] = this.userAvatarConfigurationId;
        data["UserId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAvatarConfiguration extends IUserAvatarConfigurationWithoutId {
    userAvatarConfigurationId: string;
    userId: string;
}

export class UserGroupWithoutId implements IUserGroupWithoutId {
    userGroupName!: string;
    companyId!: string;
    description?: string;
    isDefaultUserGroup?: boolean;

    constructor(data?: IUserGroupWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isDefaultUserGroup = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupName = _data["UserGroupName"];
            this.companyId = _data["CompanyId"];
            this.description = _data["Description"];
            this.isDefaultUserGroup = _data["IsDefaultUserGroup"] !== undefined ? _data["IsDefaultUserGroup"] : false;
        }
    }

    static fromJS(data: any): UserGroupWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupName"] = this.userGroupName;
        data["CompanyId"] = this.companyId;
        data["Description"] = this.description;
        data["IsDefaultUserGroup"] = this.isDefaultUserGroup;
        return data;
    }
}

export interface IUserGroupWithoutId {
    userGroupName: string;
    companyId: string;
    description?: string;
    isDefaultUserGroup?: boolean;
}

export class UserGroup extends UserGroupWithoutId implements IUserGroup {
    userGroupId!: string;
    experienceCount!: number;
    userCount!: number;

    constructor(data?: IUserGroup) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.experienceCount = _data["ExperienceCount"];
            this.userCount = _data["UserCount"];
        }
    }

    static fromJS(data: any): UserGroup {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["ExperienceCount"] = this.experienceCount;
        data["UserCount"] = this.userCount;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGroup extends IUserGroupWithoutId {
    userGroupId: string;
    experienceCount: number;
    userCount: number;
}

export class BaseUser implements IBaseUser {
    forename!: string;
    surname!: string;
    emailAddress!: string;
    username?: string;
    language!: string;
    jobTitle?: string;
    site?: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role!: UserRole;
    country!: string;

    constructor(data?: IBaseUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forename = _data["Forename"];
            this.surname = _data["Surname"];
            this.emailAddress = _data["EmailAddress"];
            this.username = _data["Username"];
            this.language = _data["Language"];
            this.jobTitle = _data["JobTitle"];
            this.site = _data["Site"];
            this.role = _data["Role"];
            this.country = _data["Country"];
        }
    }

    static fromJS(data: any): BaseUser {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Forename"] = this.forename;
        data["Surname"] = this.surname;
        data["EmailAddress"] = this.emailAddress;
        data["Username"] = this.username;
        data["Language"] = this.language;
        data["JobTitle"] = this.jobTitle;
        data["Site"] = this.site;
        data["Role"] = this.role;
        data["Country"] = this.country;
        return data;
    }
}

export interface IBaseUser {
    forename: string;
    surname: string;
    emailAddress: string;
    username?: string;
    language: string;
    jobTitle?: string;
    site?: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role: UserRole;
    country: string;
}

export class User extends BaseUser implements IUser {
    userId!: string;
    companyId!: string;
    profilePictureUrl?: string;
    lastLogin?: Date;

    constructor(data?: IUser) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["UserId"];
            this.companyId = _data["CompanyId"];
            this.profilePictureUrl = _data["ProfilePictureUrl"];
            this.lastLogin = _data["LastLogin"] ? new Date(_data["LastLogin"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CompanyId"] = this.companyId;
        data["ProfilePictureUrl"] = this.profilePictureUrl;
        data["LastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUser extends IBaseUser {
    userId: string;
    companyId: string;
    profilePictureUrl?: string;
    lastLogin?: Date;
}

export class UserWithCompanyName extends User implements IUserWithCompanyName {
    companyName?: string;

    constructor(data?: IUserWithCompanyName) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyName = _data["CompanyName"];
        }
    }

    static fromJS(data: any): UserWithCompanyName {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithCompanyName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyName"] = this.companyName;
        super.toJSON(data);
        return data;
    }
}

export interface IUserWithCompanyName extends IUser {
    companyName?: string;
}

export class FullUserForCreate extends User implements IFullUserForCreate {
    password!: string;

    constructor(data?: IFullUserForCreate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): FullUserForCreate {
        data = typeof data === 'object' ? data : {};
        let result = new FullUserForCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface IFullUserForCreate extends IUser {
    password: string;
}

export class FullUserForUpdate extends User implements IFullUserForUpdate {
    password?: string;

    constructor(data?: IFullUserForUpdate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): FullUserForUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new FullUserForUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface IFullUserForUpdate extends IUser {
    password?: string;
}

export class UserWithStatus extends User implements IUserWithStatus {
    status?: UserStatus;

    constructor(data?: IUserWithStatus) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["Status"] ? UserStatus.fromJS(_data["Status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status ? this.status.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserWithStatus extends IUser {
    status?: UserStatus;
}

export class UserStatus implements IUserStatus {
    isOnline!: boolean;
    desktopSessions?: DesktopSession[];
    vRSession?: VRSession;

    constructor(data?: IUserStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnline = _data["IsOnline"];
            if (Array.isArray(_data["DesktopSessions"])) {
                this.desktopSessions = [] as any;
                for (let item of _data["DesktopSessions"])
                    this.desktopSessions!.push(DesktopSession.fromJS(item));
            }
            this.vRSession = _data["VRSession"] ? VRSession.fromJS(_data["VRSession"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsOnline"] = this.isOnline;
        if (Array.isArray(this.desktopSessions)) {
            data["DesktopSessions"] = [];
            for (let item of this.desktopSessions)
                data["DesktopSessions"].push(item.toJSON());
        }
        data["VRSession"] = this.vRSession ? this.vRSession.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserStatus {
    isOnline: boolean;
    desktopSessions?: DesktopSession[];
    vRSession?: VRSession;
}

export class DesktopSession implements IDesktopSession {
    wentOnlineTime?: Date;
    applicationType?: string | undefined;
    deviceName?: string | undefined;

    constructor(data?: IDesktopSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
            this.applicationType = _data["ApplicationType"];
            this.deviceName = _data["DeviceName"];
        }
    }

    static fromJS(data: any): DesktopSession {
        data = typeof data === 'object' ? data : {};
        let result = new DesktopSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        data["ApplicationType"] = this.applicationType;
        data["DeviceName"] = this.deviceName;
        return data;
    }
}

export interface IDesktopSession {
    wentOnlineTime?: Date;
    applicationType?: string | undefined;
    deviceName?: string | undefined;
}

export class VRSession implements IVRSession {
    wentOnlineTime?: Date;
    tagName?: string;
    applicationType?: string;
    deviceName?: string;
    sessionId!: string;
    /** MapPath of the RoomMetadata */
    roomName?: string;
    isRoomFull?: boolean;
    gameSessionType?: SessionType;
    serverAddress?: string;
    region?: string;

    constructor(data?: IVRSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
            this.tagName = _data["TagName"];
            this.applicationType = _data["ApplicationType"];
            this.deviceName = _data["DeviceName"];
            this.sessionId = _data["SessionId"];
            this.roomName = _data["RoomName"];
            this.isRoomFull = _data["IsRoomFull"];
            this.gameSessionType = _data["GameSessionType"];
            this.serverAddress = _data["ServerAddress"];
            this.region = _data["Region"];
        }
    }

    static fromJS(data: any): VRSession {
        data = typeof data === 'object' ? data : {};
        let result = new VRSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        data["TagName"] = this.tagName;
        data["ApplicationType"] = this.applicationType;
        data["DeviceName"] = this.deviceName;
        data["SessionId"] = this.sessionId;
        data["RoomName"] = this.roomName;
        data["IsRoomFull"] = this.isRoomFull;
        data["GameSessionType"] = this.gameSessionType;
        data["ServerAddress"] = this.serverAddress;
        data["Region"] = this.region;
        return data;
    }
}

export interface IVRSession {
    wentOnlineTime?: Date;
    tagName?: string;
    applicationType?: string;
    deviceName?: string;
    sessionId: string;
    /** MapPath of the RoomMetadata */
    roomName?: string;
    isRoomFull?: boolean;
    gameSessionType?: SessionType;
    serverAddress?: string;
    region?: string;
}

export class CreateUserRequest extends BaseUser implements ICreateUserRequest {
    invitationToken!: string;
    password?: string;

    constructor(data?: ICreateUserRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invitationToken = _data["InvitationToken"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvitationToken"] = this.invitationToken;
        data["Password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateUserRequest extends IBaseUser {
    invitationToken: string;
    password?: string;
}

export class UserAccessData implements IUserAccessData {
    userId!: string;
    userGroupId?: string;
    expiresAt?: Date;

    constructor(data?: IUserAccessData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAccessData {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccessData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserAccessData {
    userId: string;
    userGroupId?: string;
    expiresAt?: Date;
}

export class UserGroupAccessData implements IUserGroupAccessData {
    userGroupId!: string;
    expiresAt?: Date;

    constructor(data?: IUserGroupAccessData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserGroupAccessData {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupAccessData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserGroupAccessData {
    userGroupId: string;
    expiresAt?: Date;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    userIdentifier!: string;
    isV2?: boolean;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isV2 = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.isV2 = _data["IsV2"] !== undefined ? _data["IsV2"] : false;
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["IsV2"] = this.isV2;
        return data;
    }
}

export interface IResetPasswordRequest {
    userIdentifier: string;
    isV2?: boolean;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    userIdentifier!: string;
    password!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.password = _data["Password"];
            this.newPassword = _data["NewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["Password"] = this.password;
        data["NewPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    userIdentifier: string;
    password: string;
    newPassword: string;
}

export class Relationship implements IRelationship {
    user1Id!: string;
    user2Id!: string;

    constructor(data?: IRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user1Id = _data["User1Id"];
            this.user2Id = _data["User2Id"];
        }
    }

    static fromJS(data: any): Relationship {
        data = typeof data === 'object' ? data : {};
        let result = new Relationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["User1Id"] = this.user1Id;
        data["User2Id"] = this.user2Id;
        return data;
    }
}

export interface IRelationship {
    user1Id: string;
    user2Id: string;
}

export class Login implements ILogin {
    userIdentifier!: string;
    password!: string;
    source?: SessionSource;
    clientId?: string;
    machineId?: number;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["UserIdentifier"];
            this.password = _data["Password"];
            this.source = _data["Source"];
            this.clientId = _data["ClientId"];
            this.machineId = _data["MachineId"];
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserIdentifier"] = this.userIdentifier;
        data["Password"] = this.password;
        data["Source"] = this.source;
        data["ClientId"] = this.clientId;
        data["MachineId"] = this.machineId;
        return data;
    }
}

export interface ILogin {
    userIdentifier: string;
    password: string;
    source?: SessionSource;
    clientId?: string;
    machineId?: number;
}

export class ExchangeToken implements IExchangeToken {
    sessionSource!: SessionSource;

    constructor(data?: IExchangeToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionSource = _data["SessionSource"];
        }
    }

    static fromJS(data: any): ExchangeToken {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionSource"] = this.sessionSource;
        return data;
    }
}

export interface IExchangeToken {
    sessionSource: SessionSource;
}

export class LoginResult implements ILoginResult {
    token!: string;
    refreshToken!: string;

    constructor(data?: ILoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.refreshToken = _data["RefreshToken"];
        }
    }

    static fromJS(data: any): LoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["RefreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILoginResult {
    token: string;
    refreshToken: string;
}

export class InvitationWithoutId implements IInvitationWithoutId {
    isV2?: boolean;
    inviteeEmail!: string;

    constructor(data?: IInvitationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isV2 = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isV2 = _data["IsV2"] !== undefined ? _data["IsV2"] : false;
            this.inviteeEmail = _data["InviteeEmail"];
        }
    }

    static fromJS(data: any): InvitationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsV2"] = this.isV2;
        data["InviteeEmail"] = this.inviteeEmail;
        return data;
    }
}

export interface IInvitationWithoutId {
    isV2?: boolean;
    inviteeEmail: string;
}

export class InvitationSummary implements IInvitationSummary {
    createdAt?: Date;
    expiration?: Date;
    inviteeEmail?: string;

    constructor(data?: IInvitationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["CreatedAt"] ? new Date(_data["CreatedAt"].toString()) : <any>undefined;
            this.expiration = _data["Expiration"] ? new Date(_data["Expiration"].toString()) : <any>undefined;
            this.inviteeEmail = _data["InviteeEmail"];
        }
    }

    static fromJS(data: any): InvitationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["InviteeEmail"] = this.inviteeEmail;
        return data;
    }
}

export interface IInvitationSummary {
    createdAt?: Date;
    expiration?: Date;
    inviteeEmail?: string;
}

export class ContactRequest extends User implements IContactRequest {
    invitationSentTime?: Date;

    constructor(data?: IContactRequest) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invitationSentTime = _data["InvitationSentTime"] ? new Date(_data["InvitationSentTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvitationSentTime"] = this.invitationSentTime ? this.invitationSentTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IContactRequest extends IUser {
    invitationSentTime?: Date;
}

export class Permission implements IPermission {
    canRecordPrivateReplay?: boolean;
    canRecordInternalReplay?: boolean;
    canRecordPublicReplay?: boolean;
    storageSizeLimitMiB?: number;
    canUseSpectatorMode?: boolean;
    canApproveReplays?: boolean;
    displayPartnerCompanies?: boolean;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canRecordPrivateReplay = _data["CanRecordPrivateReplay"];
            this.canRecordInternalReplay = _data["CanRecordInternalReplay"];
            this.canRecordPublicReplay = _data["CanRecordPublicReplay"];
            this.storageSizeLimitMiB = _data["StorageSizeLimitMiB"];
            this.canUseSpectatorMode = _data["CanUseSpectatorMode"];
            this.canApproveReplays = _data["CanApproveReplays"];
            this.displayPartnerCompanies = _data["DisplayPartnerCompanies"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanRecordPrivateReplay"] = this.canRecordPrivateReplay;
        data["CanRecordInternalReplay"] = this.canRecordInternalReplay;
        data["CanRecordPublicReplay"] = this.canRecordPublicReplay;
        data["StorageSizeLimitMiB"] = this.storageSizeLimitMiB;
        data["CanUseSpectatorMode"] = this.canUseSpectatorMode;
        data["CanApproveReplays"] = this.canApproveReplays;
        data["DisplayPartnerCompanies"] = this.displayPartnerCompanies;
        return data;
    }
}

export interface IPermission {
    canRecordPrivateReplay?: boolean;
    canRecordInternalReplay?: boolean;
    canRecordPublicReplay?: boolean;
    storageSizeLimitMiB?: number;
    canUseSpectatorMode?: boolean;
    canApproveReplays?: boolean;
    displayPartnerCompanies?: boolean;
}

export class CreateBatchUserRequest implements ICreateBatchUserRequest {
    quantity!: number;
    userNamePrefix!: string;
    password!: string;
    emailDomain!: string;
    emailNamePrefix!: string;
    forename!: string;
    surname!: string;
    jobTitle?: string;
    country!: string;
    language!: string;
    companyId!: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role!: UserRole;

    constructor(data?: ICreateBatchUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["Quantity"];
            this.userNamePrefix = _data["UserNamePrefix"];
            this.password = _data["Password"];
            this.emailDomain = _data["EmailDomain"];
            this.emailNamePrefix = _data["EmailNamePrefix"];
            this.forename = _data["Forename"];
            this.surname = _data["Surname"];
            this.jobTitle = _data["JobTitle"];
            this.country = _data["Country"];
            this.language = _data["Language"];
            this.companyId = _data["CompanyId"];
            this.role = _data["Role"];
        }
    }

    static fromJS(data: any): CreateBatchUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quantity"] = this.quantity;
        data["UserNamePrefix"] = this.userNamePrefix;
        data["Password"] = this.password;
        data["EmailDomain"] = this.emailDomain;
        data["EmailNamePrefix"] = this.emailNamePrefix;
        data["Forename"] = this.forename;
        data["Surname"] = this.surname;
        data["JobTitle"] = this.jobTitle;
        data["Country"] = this.country;
        data["Language"] = this.language;
        data["CompanyId"] = this.companyId;
        data["Role"] = this.role;
        return data;
    }
}

export interface ICreateBatchUserRequest {
    quantity: number;
    userNamePrefix: string;
    password: string;
    emailDomain: string;
    emailNamePrefix: string;
    forename: string;
    surname: string;
    jobTitle?: string;
    country: string;
    language: string;
    companyId: string;
    /** All users are now created as User. Roles are defined via separate constructs. */
    role: UserRole;
}

export class ReleaseChannel implements IReleaseChannel {
    releaseChannelId!: string;
    requirements!: ReleaseChannelRequirements;
    userGroupId?: string;
    expiresAt?: Date;

    constructor(data?: IReleaseChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.releaseChannelId = _data["ReleaseChannelId"];
            this.requirements = _data["Requirements"];
            this.userGroupId = _data["UserGroupId"];
            this.expiresAt = _data["ExpiresAt"] ? new Date(_data["ExpiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReleaseChannel {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReleaseChannelId"] = this.releaseChannelId;
        data["Requirements"] = this.requirements;
        data["UserGroupId"] = this.userGroupId;
        data["ExpiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReleaseChannel {
    releaseChannelId: string;
    requirements: ReleaseChannelRequirements;
    userGroupId?: string;
    expiresAt?: Date;
}

export enum ReleaseChannelRequirements {
    Optional = "Optional",
    AutoQueue = "AutoQueue",
    Required = "Required",
}

export enum AvatarType {
    Stylized = "Stylized",
    Realistic = "Realistic",
}

export enum SessionSource {
    Launcher = "Launcher",
    VirtualReality = "VirtualReality",
    MobileAndroid = "MobileAndroid",
    MobileIos = "MobileIos",
    HoloLens = "HoloLens",
    OculusQuest = "OculusQuest",
    WebFrontend = "WebFrontend",
    DesktopApp = "DesktopApp",
}

/** All users are now created as User. Roles are defined via separate constructs. */
export enum UserRole {
    User = "User",
    CompanyAdministrator = "CompanyAdministrator",
    Administrator = "Administrator",
}

export enum SessionType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export class PasswordValidationResult implements IPasswordValidationResult {
    email!: boolean;
    invalidSymbolChar!: boolean;
    jobTitle!: boolean;
    length!: boolean;
    lowercaseChar!: boolean;
    name!: boolean;
    numberChar!: boolean;
    symbolChar!: boolean;
    uppercaseChar!: boolean;

    constructor(data?: IPasswordValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["Email"];
            this.invalidSymbolChar = _data["InvalidSymbolChar"];
            this.jobTitle = _data["JobTitle"];
            this.length = _data["Length"];
            this.lowercaseChar = _data["LowercaseChar"];
            this.name = _data["Name"];
            this.numberChar = _data["NumberChar"];
            this.symbolChar = _data["SymbolChar"];
            this.uppercaseChar = _data["UppercaseChar"];
        }
    }

    static fromJS(data: any): PasswordValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        data["InvalidSymbolChar"] = this.invalidSymbolChar;
        data["JobTitle"] = this.jobTitle;
        data["Length"] = this.length;
        data["LowercaseChar"] = this.lowercaseChar;
        data["Name"] = this.name;
        data["NumberChar"] = this.numberChar;
        data["SymbolChar"] = this.symbolChar;
        data["UppercaseChar"] = this.uppercaseChar;
        return data;
    }
}

export interface IPasswordValidationResult {
    email: boolean;
    invalidSymbolChar: boolean;
    jobTitle: boolean;
    length: boolean;
    lowercaseChar: boolean;
    name: boolean;
    numberChar: boolean;
    symbolChar: boolean;
    uppercaseChar: boolean;
}

export class UserSetting implements IUserSetting {
    settingKey!: string;
    settingValue!: string;

    constructor(data?: IUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingKey = _data["SettingKey"];
            this.settingValue = _data["SettingValue"];
        }
    }

    static fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SettingKey"] = this.settingKey;
        data["SettingValue"] = this.settingValue;
        return data;
    }
}

export interface IUserSetting {
    settingKey: string;
    settingValue: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */